import { WidgetWrapper } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';

interface Props {
  readonly properties: {
    readonly image: string;
    readonly title: string;
    readonly description: string;
    readonly link: string;
  }[];
}

export function PartnerMarketOfferWidget(props: Props) {
  if (!props.properties?.length) {
    return (
      <WidgetWrapper title="Ähnliche Immobilien aus der Umgebung auf dem Markt">
        <EmptyState description="Es sind keine ähnlichen Immobilien aus der Umgebung auf dem Markt." />
      </WidgetWrapper>
    );
  }

  return (
    <WidgetWrapper title="Ähnliche Immobilien aus der Umgebung auf dem Markt">
      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
        {props.properties?.map((it) => (
          <li key={it.title}>
            <a
              href={it.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col gap-2 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden hover:opacity-50"
            >
              <img
                src={it.image}
                alt=""
                className="aspect-4/3 object-cover w-full"
              />
              <div className="flex flex-col gap-2 p-4 pt-2 text-sm">
                <h3 className="font-bold">{it.title}</h3>
                <p className="whitespace-pre-line">{it.description}</p>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </WidgetWrapper>
  );
}
